module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "id": "admin-screen"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('a', {
    staticClass: "back-to-list",
    attrs: {
      "href": "/"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "icon md-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t("booking.detail.back_to_list")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "row automation-filter-area panel-heading"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('div', {
    staticClass: "title text-uppercase panel-title"
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.id),
      expression: "id"
    }]
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.$t('admin.' + _vm.type + '.edit.title')) + "  ")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.id),
      expression: "!id"
    }]
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.$t('admin.' + _vm.type + '.create.title')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8"
  }, [_c('div', {
    staticClass: "btn_area"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.id ? _vm.update_contract() : _vm.create_template()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.save")))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel settings-page"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body bg-white"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('admin.contract.create.name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract.name),
      expression: "contract.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "required": "required"
    },
    domProps: {
      "value": (_vm.contract.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contract, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('redactor', {
    attrs: {
      "contract": _vm.contract.content,
      "rentalId": "1"
    },
    model: {
      value: (_vm.contract),
      callback: function($$v) {
        _vm.contract = $$v
      },
      expression: "contract"
    }
  })], 1)])])])])])])])])])])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d31b21fc"}!./src/app/pages/admin/template/edit/edit.html
// module id = 1453
// module chunks = 0